import script from "./AdminProductDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductDashboardView.vue?vue&type=style&index=0&id=c8e260b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e260b0"]])

export default __exports__